import { render, staticRenderFns } from "./UniversitySelectbox.vue?vue&type=template&id=12cd97d7&"
import script from "./UniversitySelectbox.vue?vue&type=script&lang=js&"
export * from "./UniversitySelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports